import { render, staticRenderFns } from "./ScreenshotWrapper.vue?vue&type=template&id=e3aeab9a&scoped=true"
import script from "./ScreenshotWrapper.vue?vue&type=script&lang=js"
export * from "./ScreenshotWrapper.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotWrapper.vue?vue&type=style&index=0&id=e3aeab9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3aeab9a",
  null
  
)

export default component.exports